import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Api } from '@brokerage/utils/Api';

export const fetchConfigFields = createAsyncThunk(
  'configFields/fetchConfigFields',
  async ({ page = 1, search_term = '' }, { getState, rejectWithValue }) => {
    try {
      const state = getState().configFields;

      const cacheKey = search_term ? `${page}_${search_term}` : `${page}`;

      if (state.cache[cacheKey]) {
        return {
          ...state.cache[cacheKey],
          cacheKey,
          currentPage: page,
          searchTerm: search_term,
          fromCache: true
        };
      }

      const response = await Api.loadConfigFields({ page, search_term });
      const pagination = JSON.parse(response.headers['x-pagination']);
      const data = response.data;

      return {
        data,
        pagination,
        cacheKey,
        fromCache: false,
        currentPage: page,
        searchTerm: search_term
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch config fields');
    }
  }
);

const configFieldsSlice = createSlice({
  name: 'configFields',
  initialState: {
    configFields: [],
    pagination: {},
    loading: false,
    cache: {},
    error: null,
    currentPage: 1,
    searchTerm: ''
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    clearCache: state => {
      state.cache = {};
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchConfigFields.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConfigFields.fulfilled, (state, action) => {
        state.loading = false;
        state.configFields = action.payload.data;
        state.pagination = action.payload.pagination;
        state.currentPage = action.payload.currentPage;
        state.searchTerm = action.payload.searchTerm;
        if (!action.payload.fromCache) {
          state.cache[action.payload.cacheKey] = {
            data: action.payload.data,
            pagination: action.payload.pagination
          };
        }
      })
      .addCase(fetchConfigFields.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  }
});

export const { setCurrentPage, setSearchTerm, clearCache } = configFieldsSlice.actions;
export default configFieldsSlice.reducer;
